var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.add
    }
  }, [_vm._v("新增")])], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_vm._l(_vm.config, function (row, key) {
    return _c("el-table-column", {
      key: key,
      attrs: {
        prop: row.paramName,
        label: row.paramDesc
      }
    });
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "230px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          on: {
            click: function click($event) {
              return _vm.edit(scope.row);
            }
          }
        }, [_vm._v("修改")]), _c("el-button", {
          attrs: {
            type: "danger"
          },
          on: {
            click: function click($event) {
              return _vm.del(scope.row);
            }
          }
        }, [_vm._v("删除")]), _vm.isShowCopy ? _c("el-button", {
          attrs: {
            type: "success"
          },
          on: {
            click: function click($event) {
              return _vm.copy(scope.row);
            }
          }
        }, [_vm._v("复制")]) : _vm._e()];
      }
    }])
  })], 2), _c("el-dialog", {
    attrs: {
      title: "编辑",
      visible: _vm.dialogFormVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "right",
      "label-width": "120px",
      model: _vm.formData
    }
  }, _vm._l(_vm.config, function (row, key) {
    return _c("el-form-item", {
      key: key,
      attrs: {
        label: row.paramDesc
      }
    }, [row.paramType == "string" ? _c("el-input", {
      attrs: {
        disabled: row.isPrimaryKey == 1 && _vm.formType == "update"
      },
      model: {
        value: _vm.formData[row.paramName],
        callback: function callback($$v) {
          _vm.$set(_vm.formData, row.paramName, $$v);
        },
        expression: "formData[row.paramName]"
      }
    }) : _vm._e(), row.paramType == "int" ? _c("el-input-number", {
      attrs: {
        controls: false,
        disabled: row.isPrimaryKey == 1 && _vm.formType == "update",
        min: 0
      },
      model: {
        value: _vm.formData[row.paramName],
        callback: function callback($$v) {
          _vm.$set(_vm.formData, row.paramName, $$v);
        },
        expression: "formData[row.paramName]"
      }
    }) : _vm._e()], 1);
  }), 1), _c("div", {
    staticClass: "footer"
  }, [_vm.formType == "add" ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.create();
      }
    }
  }, [_vm._v("创建")]) : _vm._e(), _vm.formType == "update" ? _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.update();
      }
    }
  }, [_vm._v("修改")]) : _vm._e()], 1)], 1), _c("div", [_vm.centerDialogVisible ? _c("el-dialog", {
    attrs: {
      title: "复制粘贴",
      visible: _vm.centerDialogVisible,
      width: "40%",
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.centerDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-position": "right",
      "label-width": "120px",
      model: _vm.agentInfo
    }
  }, _vm._l(_vm.config, function (row, key) {
    return _c("div", {
      key: key
    }, [(row.isPrimaryKey === 1 ? true : false) ? _c("el-form-item", {
      attrs: {
        label: row.paramDesc
      }
    }, [_vm._v(" " + _vm._s(_vm.agentInfo[row.paramName]) + " ")]) : _vm._e(), (row.isPrimaryKey === 1 ? true : false) ? _c("el-form-item", {
      attrs: {
        label: "copy_" + row.paramName
      }
    }, [_c("el-input", {
      model: {
        value: _vm.copyID,
        callback: function callback($$v) {
          _vm.copyID = $$v;
        },
        expression: "copyID"
      }
    })], 1) : _vm._e()], 1);
  }), 0), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: function click($event) {
        _vm.centerDialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.copySuc();
      }
    }
  }, [_vm._v("确 定")])], 1)], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };